import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import cx from 'classnames';

import {
  SessionStorageManager,
  useArchivedCategoryState,
  useArchivedEventState,
  useArchivedSportsbookState,
  useArchivedSportState,
  useArchivedTournamentState,
} from '@atlas/core';
import { EventResultsCard, Icon } from '@atlas/ui';

import { ARCHIVED_EVENT_EXTRA_DATA_STORAGE_KEY } from 'common/constants';

const EventItem = props => {
  const { children, className, eventId } = props;
  const { pathname } = useLocation();
  const { push: historyPush } = useHistory();
  const { updateArchivedSportsbookState } = useArchivedSportsbookState();
  const { updateArchivedEventState } = useArchivedEventState();

  const { name: sportName } = useArchivedSportState();
  const { imagePaths: categoryImagePaths, name: categoryName } = useArchivedCategoryState();
  const { imagePaths: tournamentImagePaths, name: tournamentName } = useArchivedTournamentState();

  const handleSetName = useCallback(() => {
    const extraData = {
      categoryImagePaths,
      categoryName,
      sportName,
      tournamentImagePaths,
      tournamentName,
    };

    SessionStorageManager.setItem(
      `${ARCHIVED_EVENT_EXTRA_DATA_STORAGE_KEY}_${eventId}`,
      JSON.stringify(extraData),
    );
    updateArchivedSportsbookState({
      selectedEventId: eventId,
      selectedEventUrlName: eventId,
    });
    updateArchivedEventState({
      ...extraData,
      error: null,
      initialized: false,
      loading: true,
    });
    historyPush(`${pathname}?r=${eventId}`);
  }, [
    categoryImagePaths,
    categoryName,
    eventId,
    historyPush,
    pathname,
    sportName,
    tournamentImagePaths,
    tournamentName,
    updateArchivedEventState,
    updateArchivedSportsbookState,
  ]);

  return (
    <div className={className} onClick={handleSetName}>
      {children}
    </div>
  );
};

const ResultsEventsListItem = ({ event }) => {
  const { selectedEventId } = useArchivedSportsbookState();

  const className = cx('event-card', { active: selectedEventId === event.id });

  const statisticIndicator = () => {
    if (event.widgets?.some(widget => widget.type === 'STATISTIC')) {
      return (
        <div className="statistic-indicator">
          <Icon height={16} name="match-statistic" width={16} />
        </div>
      );
    }
    return null;
  };

  return (
    <EventItem className={className} eventId={event.id}>
      <h4 className="d-none">
        {event.outright
          ? `${event.name}`
          : `${event?.participants?.home?.fullName} - ${event?.participants?.away?.fullName}`}
      </h4>
      <EventResultsCard
        StatisticIndicator={statisticIndicator}
        awayScore={event.info?.score?.awayScore}
        event={event}
        homeScore={event.info?.score?.homeScore}
        key={event.id}
        participants={event.participants}
        startTime={event.startTime}
      />
    </EventItem>
  );
};

export default ResultsEventsListItem;
